import { useMutation } from '@tanstack/react-query';
import * as overlayServices from 'services/overlay';
import {
  deleteProductOverlays,
  retargetProductOverlay,
} from 'services/overlay';

export const useMutateCreateProductOverlay = () => {
  return useMutation({
    mutationFn: async ({ productItemId, targetMemberId }) => {
      const params = { productItemId, targetMemberId };
      const { isSuccess, message, data } =
        await overlayServices.createProductOverlay(params);

      if (isSuccess) {
        return Promise.resolve(data);
      } else {
        return Promise.reject(message || 'Server Error');
      }
    },
  });
};
